export const isTokenExpired = () => {
   try {
      const token = localStorage.getItem('access');
      if (!token || token === 'null' || token === 'undefined') return true;

      const cleanToken = token.replace(/"/g, '');
      if (!cleanToken || cleanToken.split('.').length !== 3) return true;

      const payload = JSON.parse(atob(cleanToken.split('.')[1]));
      if (!payload || !payload.exp) return true;

      const exp = payload.exp * 1000;
      const now = Date.now();

      // ✅ 5 second buffer - FIXED
      const bufferTime = 5000;
      const isExpired = now >= (exp - bufferTime);
      return isExpired;
   } catch (error) {
      console.error('Token check error:', error);
      return true;
   }
};

export const isAuthenticated = () => {
   const token = localStorage.getItem('access');
   if (!token || token === 'null' || token === 'undefined') {
      return false;
   }
   if (isTokenExpired()) {
      localStorage.clear();
      return false;
   }
   return true;
};

export const forceLogout = () => {
   localStorage.clear();
   window.location.href = '/';
};

// ✅ Token Watcher
let intervalId = null;

export const startTokenWatcher = () => {
   if (intervalId) stopTokenWatcher();

   const checkToken = () => {
      if (!localStorage.getItem('access')) {
         stopTokenWatcher();
         return;
      }
      if (isTokenExpired()) {
         forceLogout();
         stopTokenWatcher();
      }
   };

   // ✅ Check every 30 seconds - FIXED
   intervalId = setInterval(checkToken, 30000);
   setTimeout(checkToken, 10000); // First check after 10s

};

export const stopTokenWatcher = () => {
   if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
   }
};

// ✅ Get token info
export const getTokenExpiryTime = () => {
   try {
      const token = localStorage.getItem('access');
      if (!token) return null;

      const payload = JSON.parse(atob(token.replace(/"/g, '').split('.')[1]));
      const exp = payload.exp * 1000;
      const now = Date.now();
      const timeLeft = Math.floor((exp - now) / 1000);

      return {
         expiresAt: new Date(exp),
         timeLeftSeconds: timeLeft,
         timeLeftMinutes: Math.floor(timeLeft / 60),
         isExpired: timeLeft <= 0
      };
   } catch {
      return null;
   }
};